<template>
  <div style="display: flex;margin: 50px">
    <el-select filterable v-model="params.WarehouseId" placeholder="请选择" style="margin-right: 10px">
      <el-option v-for="(item) in WarehouseList" :key="item.WarehouseId" :label="item.WarehouseName" :value="item.WarehouseId"></el-option>
    </el-select>
    <select-input
      placeholder="存货"
      :label="ProductName"
      v-model="params.ProductId"
      @click="openProduct"
      style="width: 180px;margin-right: 10px"
    />
    <el-button type="primary" @click="onNumeration">现存量重新计算</el-button>
    <list-dialog ref="listDialog" in-dialog selectable @select="setProduct" />
  </div>
</template>

<script>
import listDialog from '@/components/basedata/inventory/archives/listDialog'

export default {
  components: { listDialog  },
  data() {
    return {
      api: require('@/api/stock/stReport').default,
      warehouseApi: require('@/api/ba/warehouse').default,
      params: {
        ProductId: null,
        WarehouseId:null
      },
      ProductName: "",
      WarehouseList: [],
    };
  },
  mounted() {
    this.warehouseApi.list({ Status: 1 }).then((res) => {
      if (res.Code === 0) {
        this.WarehouseList = res.Data;
      }
    });
  },
  methods: {
    openProduct(){
      this.$refs.listDialog.open()
    },
    setProduct(data){
      this.ProductName = data.ProductName;
      this.params.ProductId = data.ProductId
    },
    onNumeration(){
      this.api.reCurrentStockRpt(this.params).then((res) => {
        if (res.Code === 0) {
          this.$message.success(res.Msg);
        }else{
          this.$message.error(res.Msg);
        }
      });
    }
  }
};
</script>

<style></style>
